import { render, staticRenderFns } from "./EvaluationRoleManage.vue?vue&type=template&id=5c32f324&scoped=true"
import script from "./EvaluationRoleManage.vue?vue&type=script&lang=js"
export * from "./EvaluationRoleManage.vue?vue&type=script&lang=js"
import style0 from "./EvaluationRoleManage.vue?vue&type=style&index=0&id=5c32f324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32f324",
  null
  
)

export default component.exports